export const environment = {
  production: true,
  API_SCHEME: 'https',
  API_DOMAIN: 'afrilink-api.otech-services.bj/api',
  API_FILE: 'afrilink-api.otech-services.bj',
  API_VERSION: 'v1'
};